import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-change-history',
    templateUrl: './change-history.component.html',
    styleUrls: ['./change-history.component.scss'],
    standalone: false
})
export class ChangeHistoryComponent {
  @Input() createdBy: string | null = null;
  @Input() createdOn: Date | string | null = null;
  
  @Input() lastModifiedBy: string | null = null;
  @Input() lastModifiedOn: Date | string | null = null;

  isOpen = false;

  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  close(): void {
    this.isOpen = false;
  }

}